module.exports = __webpack_public_path__ + "static/img/face-0.83f3f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/faces/face-0.jpg
// module id = yocd
// module chunks = 8